import { useHasPermission } from '../../Permissions/hooks/useHasPermission';

export const useCanEditPrompt = (territoryId?: string): boolean => {
  const hasPermission = useHasPermission();

  return (
    hasPermission('GLOBAL_CAN_UPDATE_ARTICLE') ||
    hasPermission('GLOBAL_CAN_UPDATE_OWN_ARTICLE') ||
    (!!territoryId &&
      (hasPermission('TERRITORY_CAN_UPDATE_ARTICLE', territoryId) ||
        hasPermission('TERRITORY_CAN_UPDATE_OWN_ARTICLE', territoryId)))
  );
};
